import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const rewardDistributorRoutes = [
	{
		key: "distribution-sales-orders",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/distribution/dos`,
		component: React.lazy(() => import("views/reward-views/distribution/pages/DistributionSalesOrders")),
	},
	{
		key: "distribution-moving-average",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/distribution/moving-average`,
		component: React.lazy(() => import("views/reward-views/distribution/pages/DistributionMovingAverage")),
	},
	{
		key: "distribution-current-stock",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/distribution/current-stock`,
		component: React.lazy(() => import("views/reward-views/distribution/pages/DistributionCurrentStock")),
	},
	{
		key: "distribution-logs",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/distribution/logs`,
		component: React.lazy(() => import("views/reward-views/distribution/pages/DistributionLogs")),
	},
];
